export * from './onboardingPersonalInformation.component';



// WEBPACK FOOTER //
// ./src/app/OnBoardingPersonalInformation/index.ts